<template>
  <div id="app">
    <b-button
      v-if="!iframeMode"
      :class="isChatVisible ? 'hidden' : 'btn-toggle rounded-circle'"
      :aria-expanded="isChatVisible ? 'true' : 'false'"
      aria-controls="collapse-4"
      @click="isChatVisible = !isChatVisible"
    >
      <img
        src="data:image/png;base64,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"
        alt="logo"
        class="logo"
      />
    </b-button>
    <Chatwindow v-if="isChatVisible" />
  </div>
  <!--  <div id="notfound" v-else>-->
  <!--    <div class="notfound">-->
  <!--      <div class="notfound-401">-->
  <!--        <h1>4<span>0</span>1</h1>-->
  <!--        <h2>Unauthorized</h2>-->
  <!--      </div>-->
  <!--      <p>It seems you are not an authorized person to access the chat bot. Please contact <a href="https://bots4you.de" target="_blank">Bots4You GmbH</a>!</p>-->
  <!--    </div>-->
  <!--  </div>-->
</template>
<script>
import {
  enableIframeOption,
  vueAppTitle,
  parentOriginHost,
  disableKeycloakAuthorization,
  startConversationUrlParam
} from './app.config'
const Chatwindow = () => import('./components/neela/Chatwindow.vue')
import {
  OPEN_CHAT,
  CLOSE_CHAT,
  LOG_IN,
  EMIT_FAKE_USER_LOGIN_MESSAGE,
  CLOSE_CONVERSATION,
  START_CONVERSATION,
  ACCEPTED_INVITATION,
  DECLINED_INVITATION,
  CLICKED_TRIGGER_BUTTON,
  SET_DEVICE_INFO
} from './store/action-types'
import debounce from 'lodash.debounce'
export default {
  name: 'App',
  components: {
    Chatwindow
  },
  data() {
    return {
      title: vueAppTitle,
      participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: '',
      newMessagesCount: 0,
      showTypingIndicator: 'bot', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      // specifies the color scheme for the component
      messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown),
    }
  },
  computed: {
    iframeMode() {
      return enableIframeOption === '1'
    },
    messageList() {
      if (this.$store.state.showSystemMessages) {
        return this.$store.state.socket.messageList
      }
      return this.$store.state.socket.messageList.filter(
        message => !message.isSystemMessage()
      )
    },
    isChatVisible: {
      get: function() {
        return this.$store.state.isChatOpen
      },
      set: function(newValue) {
        if (!newValue) {
          this.$store.dispatch(CLOSE_CHAT)
        } else {
          this.$store.dispatch(OPEN_CHAT)
        }
      }
    },
    isConversationStarted() {
      return this.$store.state.isStartConversation
    },
    isAuthorized() {
      const parentUrl = this.$store.state.parentUrl

      if (parentOriginHost === '') {
        return true
      }

      const parentOriginRegexList = parentOriginHost
        .split(',')
        .map(e => RegExp(e))
      const isMatch = parentOriginRegexList.some(rx => rx.test(parentUrl))
      return parentOriginHost.includes(parentUrl) || isMatch
    }
  },
  mounted() {
    if (!(enableIframeOption === '1')) {
      this.switchBodyBG()
    }
    this.$vuetify.rtl = this.$store.state.language === 'ar'

    if (
      !(disableKeycloakAuthorization === '1') &&
      this.$keycloak.authenticated
    ) {
      if (this.$keycloak.tokenParsed.groups.includes(global.realm_tenant)) {
        this.$store.dispatch(LOG_IN)
      } else {
        this.$keycloak.logoutFn()
      }
    }
    // } else if (disableKeycloakAuthorization === '1') {
    //   this.$store.dispatch(EMIT_FAKE_USER_LOGIN_MESSAGE)
    // }

    if (startConversationUrlParam === 'false')
      this.$store.dispatch(CLOSE_CONVERSATION)

    this.addMessageHandler()
  },
  destroyed() {
    this.removeMessageHandler()
  },
  methods: {
    debounceStartConversation: debounce(async function() {
      await this.$store
        .dispatch(START_CONVERSATION)
        .then(() => this.$store.dispatch(OPEN_CHAT, false))
    }, 500),
    addMessageHandler() {
      window.addEventListener('message', this.postMessageConfigListener)
    },
    removeMessageHandler() {
      window.removeEventListener('message', this.postMessageConfigListener)
    },
    applyConfig(config) {
      let root = document.documentElement
      Object.keys(config).forEach(k => {
        root.style.setProperty(`--${k}`, config[k])
        if (k === 'userInputStrokeColor') {
          root.style.setProperty(`--v-primary-base`, config[k])
        }
      })
      // this.$store.dispatch(actions.SET_CONFIG, config)
    },
    postMessageConfigListener: function(event) {
      if (event.data.type === 'setConfig') {
        this.applyConfig(event.data.config)
      } else if (event.data.type === 'click') {
        if (event.data.message === 'open') {
          sessionStorage.setItem('chatState', 'open')
          this.debounceStartConversation()
        } else if (event.data.message === 'close') {
          sessionStorage.setItem('chatState', 'closed')
          this.$store.dispatch(CLOSE_CHAT)
        } else if (event.data.message === 'accepted_invitation') {
          sessionStorage.setItem('chatState', 'open')
          sessionStorage.setItem('chatInvitation', 'accepted')
          this.debounceStartConversation()
          this.$store.dispatch(ACCEPTED_INVITATION, 'chat_invitation_accept')
        } else if (event.data.message === 'declined_invitation') {
          sessionStorage.setItem('chatInvitation', 'declined')
          this.$store.dispatch(DECLINED_INVITATION, 'chat_invitation_decline')
        } else if (event.data.message === 'clicked_trigger_button') {
          sessionStorage.setItem('chatState', 'open')
          this.debounceStartConversation()
          this.$store.dispatch(CLICKED_TRIGGER_BUTTON, 'trigger_button')
        }
      } else if (event.data.type === 'set_device_info') {
        if (event.data.device) {
          const data = {
            device: event.data.device,
            type: 'impression'
          }
          this.$store.dispatch(SET_DEVICE_INFO, data)
        }
      }
    },
    switchBodyBG() {
      document.body.style.backgroundImage = 'url(' + this.$t('bg_image') + ')'
      if (this.$store.state.locale === 'nl-NL') {
        document.body.style.backgroundColor = 'white'
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/variables.css';
@import 'node_modules/bootstrap/scss/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';

@font-face {
  font-family: 'CamptonW05-Book';
  src: url('assets/fonts/CamptonW05-Book.eot');
  src: url('assets/fonts/CamptonW05-Book.eot?#iefix')
      format('embedded-opentype'),
    url('assets/fonts/CamptonW05-Book.woff2') format('woff2'),
    url('assets/fonts/CamptonW05-Book.woff') format('woff'),
    url('assets/fonts/CamptonW05-Book.ttf') format('truetype');
  font-display: swap;
}

// Variables
// General Style
html {
  scroll-behavior: smooth;
}
body {
  font-family: 'CamptonW05-Book';
  font-weight: 400;
  background-size: 100%;
  /*background-image: url('/backgrounds/bg_en.png');*/
  background-size: cover;
  background-repeat: no-repeat;
  /*background-color: $color_secondary;
  /*background-image: url('./assets/img/bg.jpg');*/
  /*background-position: top center;*/
  /*overflow-x: hidden;*/
}
input.form-control {
  background: transparent;
}
h1 {
  color: $color_secondary;
  font-size: 77px;
}
h2 {
  color: #fff;
  text-align: center;
  width: 100%;
}
input,
textarea {
  border-radius: 20px !important;
  background-clip: inherit !important;
  -webkit-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
}
ul {
  padding-left: 20px;
  li {
    span {
      color: rgba(76, 241, 247, 1);
    }
    a {
      color: #fff;
      text-decoration: underline;
    }
  }
}
p {
  color: #7a89ac;
}
.form-group.text-light {
  font-size: 14px;
}
.shadow {
  -webkit-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
}

.btn-primary {
  background-color: rgba(76, 241, 247, 1);
  border-color: rgba(76, 241, 247, 1);
  color: #000;
  border-radius: 30px;
  padding: 10px 50px;
  &:hover {
    color: #000;
  }
}
.disc {
  background: #fff;
  border-radius: 20px;
  padding: 10px 20px;
  margin-bottom: 10px;
  text-align: left;
  float: left;
  position: relative;
  clear: both;
  -webkit-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  img {
    position: relative;
    max-width: 100%;
    max-height: 300px;
  }
}

.btn-toggle {
  height: 100px;
  width: 100px;
  padding: 0;
  background-color: $color_secondary !important;
  position: fixed;
  bottom: 50px;
  right: 50px;
  transition: all 1s linear !important;
  -o-transition: all 1s linear !important;
  -moz-transition: all 1s linear !important;
  -webkit-transition: all 1s linear !important;
}

.btn-toggle:hover {
  background-color: #212529 !important;
}

.hidden {
  display: none !important;
}

.btn-toggle > .logo {
  width: 60px;
}

// nav box
nav {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 2000;
  height: 70px;
  transition: all 0.3s cubic-bezier(0, 0, 0.58, 1) 0s;
  -o-transition: all 0.3s cubic-bezier(0, 0, 0.58, 1) 0s;
  -moz-transition: all 0.3s cubic-bezier(0, 0, 0.58, 1) 0s;
  -webkit-transition: all 0.3s cubic-bezier(0, 0, 0.58, 1) 0s;
  z-index: 999;
}

.navbar-nav {
  .nav-item {
    .nav-link {
      color: #fff;
      padding: 0.2rem 1rem !important;
      text-decoration: none;
      font-size: 1.1rem;
      -webkit-transition: all 200ms ease-out;
      -moz-transition: all 200ms ease-out;
      -o-transition: all 200ms ease-out;
      transition: all 200ms ease-out;
      border-radius: 20px;
    }
  }
  .nav-link.active {
    color: #73d7f1;
    &:hover {
      color: #73d7f1;
    }
  }
}
.logo {
  height: 25px;
}
.btn-qustion {
  padding: 8px 20px;
  border-radius: 30px;
  border: 0px;
  color: white;
  margin: 0px 4px 10px;
  -webkit-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  font-size: 15px;
  outline: 0 !important;
}
.btn-q1 {
  background: $color_primary;
  &:hover {
    background: lighten($color_primary, 5%);
    color: white;
  }
}
.btn-q2 {
  background: $color_primary;
  &:hover {
    background: lighten($color_primary, 5%);
    color: white;
  }
}

/* CSS talk bubble */
.talk-bubble {
  margin-bottom: 10px;
  position: relative;
  min-width: 100px;
  height: auto;
  background-color: #73d7f1;
  text-align: left;
  color: $color_secondary;
  padding: 10px;
  -webkit-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 5px 5px 23px 0px rgba(0, 0, 0, 0.3);
  top: 10px;
  opacity: 0;
  float: right;
}
.talkbubble {
  top: 0px;
  opacity: 1;
  -webkit-transition: 0.8s ease all;
  transition: 0.8s ease all;
}
.round {
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
}

.tri-right.btm-left-in:after {
  content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHZJREFUeNpi/P//PwM2UHLjEyOQMgDi8zAxJhwKOYHUTiA+AMRyOBUDFdoCqWdA7ArEfEA8D4hBtjCwIClSAlKzgNgZTT+InwPEkxmLr3+UBTLagTiaATf4CsSGIGc8BuIYqGfygXg51FOvgfgfVPFfIG4CCDAAupIeFCZ0te4AAAAASUVORK5CYII=);
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: 15px;
  top: auto;
  bottom: 18px;
}

// go to top

.ScrollUpButton__Container {
  -webkit-transition: 0.8s ease all;
  transition: 0.8s ease all;
  border: 0px !important;
  background-color: rgba(76, 241, 247, 1) !important;
  border-radius: 100%;
  width: 40px !important;
  height: 40px !important;
  padding-bottom: 1px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 5px !important;
}
.ScrollUpButton__Container path {
  -webkit-transition: 0.8s ease all;
  transition: 0.8s ease all;
  fill: $color_secondary !important;
}
.ScrollUpButton__Container:hover {
  background-color: rgba(76, 241, 247, 1) !important;
}
.ScrollUpButton__Container:hover path {
  fill: #fff !important;
}

// footer

footer {
  padding: 50px 0px;
  span {
    color: #fff;
  }
}

// animation
.dnone {
  opacity: 0 !important;
  -webkit-transition: 0.5s ease all;
  transition: 0.5s ease all;
}
.dblock {
  max-width: 100%;
  opacity: 1;
  -webkit-transition: 0.5s ease all;
  transition: 0.5s ease all;
}

.styleautocm {
  display: inline-block;
  p {
    margin: 0px !important;
    color: $color_secondary;
    display: initial !important;
  }
}

// anim avatar
.imgAvatar {
  position: absolute;
  left: 0px;
}

.loader {
  float: left;
}

// input

.textname,
input:disabled {
  border: 2px solid $color_primary;
  color: #73d7f1;
  background: transparent !important;
  margin: 5px 0px;
}
.btnsend {
  background: #73d7f1;
  border: 0px;
  color: $color_secondary;
  line-height: 31px;
  padding: 5px 30px !important;
  text-align: center;
  -webkit-transition: 0.3s ease all;
  transition: 0.3s ease all;
  &:hover {
    color: #fff;
    background: lighten(#73d7f1, 5%);
    -webkit-transition: 0.3s ease all;
    transition: 0.3s ease all;
  }
}
.form-control:focus {
  color: #73d7f1;
}
button:disabled {
  opacity: 0.4;
}
.privacy {
  input[type='checkbox'] {
    margin-right: 5px;
  }
  ul {
    padding-left: 0px !important;
    list-style: none;
  }
  legend {
    color: #73d7f1;
    font-size: 1rem !important;
  }
  a {
    color: #fff;
  }
  label {
    color: #fff;
    font-size: 14px;
  }
}

// media
.media {
  h4 {
    color: #fff;
    padding-left: 20px;
  }
  .item-video {
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    border: 2px solid rgba(0, 0, 0, 0);
    width: 179px !important;
    &:hover {
      border: 2px solid #73d7f1;
      -webkit-transition: 0.3s ease all;
      transition: 0.3s ease all;
      img {
        opacity: 0.7;
        -webkit-transition: 0.3s ease all;
        transition: 0.3s ease all;
      }
      .play {
        opacity: 1 !important;
        -webkit-transition: 0.3s ease all;
        transition: 0.3s ease all;
      }
      small {
        bottom: 0px;
        -webkit-transition: 0.3s ease all;
        transition: 0.3s ease all;
      }
    }
    button {
      background: none;
      border: 0px;
      float: left;
      padding: 0px;
    }
    small {
      position: absolute;
      bottom: 0px;
      width: 100%;
      left: 0;
      padding: 20px 0px;
      text-align: center;
      color: #fff;
      background: rgba(115, 215, 241, 0.7);
      bottom: -80px;
    }
    .play {
      position: absolute;
      top: 40%;
      left: 40%;
      opacity: 0;
    }
  }
  .slick-prev,
  .slick-next {
    width: 29px;
    height: 48px;
  }
  .slick-prev {
    left: -35px;
    &:before {
      /*content: url(./assets/img/media/left-arrow-slider.png) !important;*/
    }
  }
  .slick-next {
    right: -35px;
    &:before {
      /*content: url(./assets/img/media/right-arrow-slider.png) !important;*/
    }
  }
  .slick-track {
    float: left;
  }
  .slick-slide {
    text-align: center;
  }
}

// contact
.contact {
  .text-danger {
    text-align: left;
    padding-left: 10px;
  }
}

// footer

footer {
  ul {
    padding-left: 10px;
    list-style: none;
    float: left;
    margin-right: 50px;
    li {
      float: left;
      margin: 0px 10px;
    }
  }
}
figure {
  margin-bottom: 0px;
  width: 100%;
  height: 300px;
  background: -moz-linear-gradient(
    top,
    rgba(3, 26, 49, 1) 0%,
    rgba(3, 26, 49, 1) 61%,
    rgba(3, 26, 49, 0.7) 83%,
    rgba(3, 26, 49, 0) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(3, 26, 49, 1) 0%,
    rgba(3, 26, 49, 1) 61%,
    rgba(3, 26, 49, 0.7) 83%,
    rgba(3, 26, 49, 0) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(3, 26, 49, 1) 0%,
    rgba(3, 26, 49, 1) 61%,
    rgba(3, 26, 49, 0.7) 83%,
    rgba(3, 26, 49, 0) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#031a31', endColorstr='#00031a31',GradientType=0 ); /* IE6-9 */
}

// legal
.legal {
  color: #fff;
  h2 {
    padding-bottom: 50px;
    font-size: 2.5rem;
  }
  p {
    color: #fff;
  }
  a {
    color: #73d7f1;
  }
}

// mobile

@media (max-width: 575.98px) {
  .img-home {
    height: 150px !important;
  }
  nav {
    background: rgb(2, 22, 43);
    .nav-link.active {
      color: rgb(2, 22, 43) !important;
      &:hover {
        color: rgb(2, 22, 43) !important;
      }
    }
  }

  .navbar-collapse {
    background: #73d7f1;
    padding: 10px;
  }

  .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
  }
  .pfull-div,
  .pfull-media {
    padding: 0px 20px;
  }
  .media .slick-prev {
    left: 30px;
    z-index: 9;
  }
  .media .slick-next {
    right: 30px;
    z-index: 9;
  }
  .sticky {
    padding-top: 75px;
  }
  figure img {
    width: 40%;
    height: auto;
  }
  .media h4 {
    text-align: center;
    padding-left: 0px;
  }
  footer {
    ul {
      padding: 0px;
      margin: 0px;
    }
  }
  .media .item-video small {
    bottom: 0px;
  }
  .media .item-video .play {
    opacity: 1;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .img-home {
    height: 150px !important;
  }
  nav {
    background: rgb(2, 22, 43);
    .nav-link.active {
      color: rgb(2, 22, 43) !important;
      &:hover {
        color: rgb(2, 22, 43) !important;
      }
    }
  }
  .navbar-collapse {
    background: #73d7f1;
    padding: 10px;
  }

  .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
  }
  .media h4 {
    text-align: center;
    padding-left: 0px;
  }
  footer {
    ul {
      padding: 0px;
      margin: 0px;
    }
  }
  .media .item-video small {
    bottom: 0px;
  }
  .media .item-video .play {
    opacity: 1;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  nav {
    background: rgb(2, 22, 43);
    .nav-link.active {
      color: rgb(2, 22, 43) !important;
      &:hover {
        color: rgb(2, 22, 43) !important;
      }
    }
  }
  .navbar-collapse {
    background: #73d7f1;
    padding: 10px;
  }

  .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
  }
}

@media screen and (min-width: 320px) and (max-width: 1080px) {
  html,
  body {
    background: #031b30;
  }
}

#notfound {
  position: relative;
  height: 100vh;
  background-color: #fff;
}

#notfound .notfound {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.notfound {
  max-width: 460px;
  width: 100%;
  text-align: center;
  line-height: 1;
}

.notfound .notfound-401 h1 {
  color: #222;
  font-size: 10rem;
  letter-spacing: 20px;
  margin: 0;
  font-weight: 700;
}

.notfound .notfound-401 h2 {
  color: #52088f;
  font-size: 2.5rem;
  text-transform: uppercase;
  letter-spacing: 5px;
}

.notfound p {
  color: #383838;
  font-size: 16px;
  font-weight: 400;
  margin-top: 20px;
  line-height: 25px;
}

.notfound p a {
  font-size: 14px;
  text-decoration: underline;
  background: transparent;
  color: #383838;
  display: inline-block;
  font-weight: 700;
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
}

.notfound p a:hover {
  color: #52088f;
}

@media only screen and (max-width: 480px) {
  .notfound .notfound-401 h1 {
    font-size: 122px;
  }
}
</style>
